module.exports = __webpack_public_path__ + "static/media/YFI-logo.cda8d5a4.png";